import {searchFieldsHaveValues} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import Vue from 'vue'
import {advancedSearchBuilder, esClient} from 'src/utilities/ptracSearch'
import {make} from 'vuex-pathify'

const initialState = {
  query: {
    streetNumber: null,
    streetName: null,
    city: null,
    zip: null,
    blockNumber: null,
    buildingNumber: null,
    floorNumber: null,
    county: null,
    jurisdiction: null,
    lotNumber: null,
    suiteNumber: null,
    state: Constants.ATS.DEFAULT.STATE,
    phase: null
  },
  quickProjectResults: [],
  remember: {
    city: false,
    county: false,
    state: false,
    zip: false,
    suiteNumber: false,
    buildingNumber: false,
    floorNumber: false,
    streetNumber: false,
    streetName: false,
    jurisdiction: false,
    lotNumber: false,
    blockNumber: false,
    phase: false
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)

getters.results = (state) => {
  return state.quickProjectResults === undefined ? [] : state.quickProjectResults
}

getters.searchFieldsHaveValues = (state) => {
  const searchFields = [
    'streetName',
    'streetNumber',
    'city',
    'zip',
    'blockNumber',
    'buildingNumber',
    'floorNumber',
    'county',
    'jurisdiction',
    'lotNumber',
    'suiteNumber',
    'phase',
  ]

  return searchFieldsHaveValues(state.query, searchFields)
}

const mutations = make.mutations(state)

mutations.resetResults = (state) => {
  state.quickProjectResults = []
}

mutations.results = (state, results) => {
  state.quickProjectResults = results
}

mutations.resetQuery = (state) => {
  for (let f in state.query) {
    if (state.remember[f] !== true) {
      Vue.set(state.query, f, initialState.query[f])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchElasticsearchResults({state, getters, commit, rootState, rootGetters}) {
      const searchFields = [
        'address.blockNumber',
        'address.buildingNumber',
        'address.floorNumber',
        'address.city',
        'address.county',
        'address.jurisdiction',
        'address.lotNumber',
        'address.phase',
        'address.state',
        'address.streetName',
        'address.streetNumber',
        'address.suiteNumber',
        'address.zip']

      const searchBody = {
        size: Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS,
        query: {
          bool: {
            must: [
              {match: {_class: Constants.ENTITY_FIELDS.PROJECT.CLASS}}
            ],
            should: [],
            filter: [{term: {active: true}}]
          }
        }
      }

      searchBody.query.bool.must.push(...advancedSearchBuilder(searchFields, state.query))

      // console.log(JSON.stringify(searchBody, null, 2))

      const esCreds = rootGetters['config/byName'](Constants.CONFIGS.ELASTICSEARCH_UN_PW)
      const response = await esClient(esCreds).search({
        index: 'ptrac',
        body: searchBody
      })

      commit('quickProjectResults', response.hits.hits)

      return response
    }
  }
}
